import React, { useState } from 'react';
import { useAuth } from '@/context/AuthContext';
import { resetPassword } from '@/services/authService';
import { Link, useNavigate } from 'react-router';
import { enqueueSnackbar } from 'notistack';
import theme from '@/constants/theme';
import { ArrowBack } from '@mui/icons-material';
import { routes } from '@/constants/routes';
import { ProfileHeader } from '@/components/profile/ProfileHeader';
import Input from '@/components/input/Input';
import Button from '@/components/input/Button';

export default function ChangePasswordScreen() {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const navigate = useNavigate();
  const { token } = useAuth();

  const handleReset = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      enqueueSnackbar({
        variant: 'error',
        message: 'Las contraseñas no coinciden.',
      });
      return;
    }

    try {
      await resetPassword(token as string, currentPassword, newPassword);
      enqueueSnackbar({
        variant: 'success',
        message: 'Contraseña actualizada con éxito.',
      });
      navigate('/profile');
    } catch (err) {
      enqueueSnackbar({
        variant: 'error',
        message: 'Error al cambiar contraseña.',
      });
    }
  };

  return (
    <div style={styles.container}>
      <Link to={routes.profile} style={styles.homeIcon}>
        <ArrowBack />
      </Link>
      <form style={styles.form} onSubmit={handleReset}>
        <ProfileHeader />
        <h1 style={styles.title}>Cambiar Contraseña</h1>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <Input
            required
            label="Contraseña actual"
            placeholder="Escribe tu contraseña actual"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
          />
          <Input
            required
            label="Nueva contraseña"
            placeholder="Escribe tu nueva contraseña"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <Input
            required
            label="Confirmar contraseña"
            placeholder="Confirma tu nueva contraseña"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </div>

        <Button sx={styles.button}>Actualizar contraseña</Button>
      </form>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: 32,
    paddingRight: 32,
    position: 'relative',
  },
  homeIcon: {
    position: 'absolute',
    top: 40,
    left: 24,
    color: theme.colors.text.default,
  },
  background: {
    flex: 1,
    justifyContent: 'center',
    paddingLeft: 32,
    paddingRight: 32,
    position: 'relative',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'transparent',
    width: 400,
  },
  title: {
    fontSize: '28px',
    fontWeight: 'bold',
    color: '#DEE7E7',
    textAlign: 'center',
    marginBottom: '16px',
  },
  subtitle: {
    fontSize: 16,
    color: theme.colors.text.body,
    textAlign: 'center',
    marginBottom: 24,
  },
  input: {
    height: 48,
    borderWidth: 1,
    borderColor: '#DEE7E7',
    borderRadius: 8,
    paddingLeft: 12,
    paddingRight: 12,
    marginBottom: 16,
    color: '#0F1A3D',
    backgroundColor: '#fff',
  },
  button: {
    justifyContent: 'center',
    fontWeight: 'bold',
    marginTop: 26,
  },
  buttonText: {
    color: '#fff',
    fontWeight: 'bold',
    fontSize: 16,
  },
};
